(function () {
    "use strict";

    angular.module("app.core").config([
        "$stateProvider",
        "$urlRouterProvider",
        function ($stateProvider, $urlRouterProvider) {
            $urlRouterProvider.otherwise(function ($injector) {
                var $location = $injector.get("$location");
                var $window = $injector.get("$window");
                const langKey = window.lang || "en";
                const path = $location.path().toLowerCase();
                const hash = $location.hash().toLowerCase();
                // /externalauth/* (e.g. /externalauth/login) excluded above; no /:lang/login route.
                if (
                    path.indexOf("/externallogin") === -1 &&
                    path.indexOf("/externalauth") === -1 &&
                    path.indexOf("/confirmoop") === -1 &&
                    path.indexOf("/token") === -1 &&
                    path.indexOf("/renew") === -1 &&
                    hash !== "mobile-widget" &&
                    path !== "/"
                ) {
                    // Full page redirect to get proper 404 HTTP status code from server
                    $window.location.replace("/" + langKey + "/404");
                }
            });
            $stateProvider
                .state("search", {
                    url: "/:langcode/{path:ara|search|buscar}?q",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("ara");
                        }],
                        q: {
                            value: null,
                            squash: false
                        }
                    },
                    resolve: {
                        // Redirect to proper analysis URL format
                        redirectToAnalysis: ['$transition$', '$state', function ($transition$, $state) {
                            var searchTerm = $transition$.params().q;
                            var langcode = $transition$.params().langcode || window.lang;

                            if (searchTerm) {
                                // Redirect to analysis.address.investment with proper format
                                // /l/{{searchTerm}}/investment
                                $transition$.abort();
                                $transition$.router.stateService.go('analysis.address.investment', {
                                    langcode: langcode,
                                    address: searchTerm,
                                    satilik: $transition$.injector().get('$translate').instant('satilik'),
                                    konut: $transition$.injector().get('$translate').instant('konut')
                                });
                            } else {
                                // No search term, go to landing
                                $transition$.abort();
                                $transition$.router.stateService.go('default', { langcode: langcode });
                            }
                        }]
                    }
                })
                .state("default", {
                    url: "/:langcode/?force&ara",
                    templateUrl: "app/content/landing/landing.html",
                    controller: "LandingController",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        force: {
                            value: null
                        }
                    },
                    resolve: {
                        // Lazy load landing bundle
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'landing');
                        }],


                        HasPackage: ['lazyLoad', 'guardSvc', function (lazyLoad, guardSvc) {
                            return guardSvc.hasPackage();
                        }],

                        HasRealEstate: ['lazyLoad', 'guardSvc', function (lazyLoad, guardSvc) {
                            return guardSvc.hasPackage([
                                "real-estate-package",
                                "location-package"
                            ]);
                        }],

                        HasLocation: ['lazyLoad', 'guardSvc', function (lazyLoad, guardSvc) {
                            return guardSvc.hasPackage(["location-package"]);
                        }],

                        RedirectIfLogin: [
                            "HasPackage",
                            "HasRealEstate",
                            "HasLocation",
                            "$transition$",
                            "$window",
                            "$q",
                            "userSvc",
                            "$rootScope",
                            "$translate",
                            function (
                                HasPackage,
                                HasRealEstate,
                                HasLocation,
                                $transition$,
                                $window,
                                $q,
                                userSvc,
                                $rootScope,
                                $translate
                            ) {
                                var deferred = $q.defer();
                                var force = $transition$.params().force;
                                if (force === 'redirect') {
                                    userSvc.getUserInfo().then(function () {
                                        try {
                                            if (userSvc.info.SignedIn) {
                                                var start = $window.userStorage.getItem('map_location');
                                                var open = $window.userStorage.getItem('map_open');
                                                var tag = null;
                                                if (open) {
                                                    switch (+open) {
                                                        case 0:
                                                            tag = "value";
                                                            break;
                                                        case 1:
                                                            tag = "demographics";
                                                            break;
                                                        case 2:
                                                            tag = "election";
                                                            break;
                                                        case 3:
                                                            tag = "comparables";
                                                            break;
                                                        case 4:
                                                            tag = "find";
                                                            break;
                                                        case 5:
                                                            tag = "competition";
                                                            break;
                                                        case 6:
                                                            tag = "opportunity";
                                                            break;
                                                        case 7:
                                                            tag = "projects";
                                                            break;
                                                        case 8:
                                                            tag = "malls";
                                                            break;
                                                        case 9:
                                                            tag = "locations";
                                                            break;
                                                        case 10:
                                                            tag = "alarm";
                                                            break;
                                                        case 11:
                                                            tag = "portfolio";
                                                            break;
                                                    }
                                                }

                                                var langKey = $transition$.params().langcode;

                                                var startObject = start ? JSON.parse(start) : { country: null, city: null, county: null, district: null };

                                                var tagCity = "country";
                                                var gObject = {
                                                    langcode: langKey,
                                                    country: $rootScope.country,
                                                };
                                                if (startObject.country) {
                                                    tagCity = "country";
                                                    gObject.country = normalizeAddress(startObject.country.split(':')[1]);
                                                }
                                                if (startObject.city) {
                                                    tagCity = "province";
                                                    gObject.country = normalizeAddress(startObject.country.split(':')[1]);
                                                    gObject.province = normalizeAddress(startObject.city.split(':')[1]);
                                                }
                                                if (startObject.county) {
                                                    tagCity = "county";
                                                    gObject.country = normalizeAddress(startObject.country.split(':')[1]);
                                                    gObject.province = normalizeAddress(startObject.city.split(':')[1]);
                                                    gObject.county = normalizeAddress(startObject.county.split(':')[1]);
                                                }
                                                if (startObject.district) {
                                                    tagCity = "neighbourhood";
                                                    gObject.country = normalizeAddress(startObject.country.split(':')[1]);
                                                    gObject.province = normalizeAddress(startObject.city.split(':')[1]);
                                                    gObject.county = normalizeAddress(startObject.county.split(':')[1]);
                                                    gObject.neighbourhood = normalizeAddress(startObject.district.split(':')[1]);
                                                }

                                                //map_location may hold localized country names ("Spain") that the
                                                //{country:world|turkiye|espana|portugal} url matcher rejects -> invalid transition
                                                var validCountries = ['world', 'turkiye', 'espana', 'portugal'];
                                                var countryAliases = { spain: 'espana', turkey: 'turkiye' };
                                                if (validCountries.indexOf(gObject.country) === -1)
                                                    gObject.country = countryAliases[gObject.country] || $rootScope.country;

                                                gObject.satilik = $translate.instant($rootScope.satilik);
                                                gObject.konut = $translate.instant($rootScope.konut);

                                                //invalid transitions skip onError hooks; without a catch the user is
                                                //left on the splash spinner forever (ES-4559)
                                                var safeGo = function (state, params) {
                                                    $transition$.router.stateService.go(state, params)
                                                        .catch(function (err) {
                                                            console.error('ES-4559 post-login redirect failed', err);
                                                            $transition$.router.stateService.go('default', { langcode: langKey });
                                                        });
                                                };


                                                tag = tag ? tag : HasLocation ? 'demographics' : (HasRealEstate || !HasPackage) ? 'portfolio' : 'value';
                                                var direction = "analysis." + tagCity + "." + tag;

                                                if (open && +open === 100) {
                                                    // Eğer open 100 ise ana sayfaya yönlendir
                                                    $transition$.router.stateService.go('default', { langcode: langKey });
                                                    deferred.resolve();
                                                } else if (open && +open !== 100 || !open || force === 'redirect') {
                                                    //son sekmeyi hatırlayıp eğer ön tanımlı bir sekme yoksa oraya yönlendirilmesi sağlanıyor

                                                    //!!!! UYARI BU ALAN SADECE PANELE YÖNLENDİRME İÇİN KULLANILIYOR. BAŞKA SAYFALAR İÇİN KULLANILAMAZ !!!!
                                                    var lastPanelState = $window.localStorage.getItem("lastVisitedPanel");
                                                    lastPanelState = lastPanelState ? JSON.parse(lastPanelState) : null;
                                                    if (lastPanelState && langKey === lastPanelState.param.langcode) {
                                                        lastPanelState.param.top = null;
                                                        lastPanelState.param.ref = null;
                                                        lastPanelState.param.e = null;
                                                        lastPanelState.param.t = null;
                                                        lastPanelState.param.d = null;
                                                        lastPanelState.param.ti = null;
                                                        lastPanelState.param.oi = null;
                                                        lastPanelState.param.l = null;

                                                        if (lastPanelState.name.indexOf('election') > -1 && lastPanelState.param.country && !lastPanelState.param.province)
                                                            lastPanelState.name = lastPanelState.name.replace('election', 'value');
                                                        else if (lastPanelState.name.indexOf('demographics') > -1 && lastPanelState.param.country && !lastPanelState.param.province)
                                                            lastPanelState.name = lastPanelState.name.replace('demographics', 'value');
                                                        else if ((lastPanelState.name.indexOf('comparables') > -1 ||
                                                            lastPanelState.name.indexOf('health') > -1 ||
                                                            lastPanelState.name.indexOf('life') > -1 ||
                                                            lastPanelState.name.indexOf('entertainment') > -1 ||
                                                            lastPanelState.name.indexOf('transportation') > -1 ||
                                                            lastPanelState.name.indexOf('education') > -1) && !lastPanelState.param.address) {
                                                            lastPanelState.name = 'analysis.country.value';
                                                            lastPanelState.param.country = $rootScope.country;
                                                        }

                                                        $transition$.abort();
                                                        if (lastPanelState && (!open || (open && +open === 100))) {
                                                            safeGo(lastPanelState.name, lastPanelState.param);
                                                        }
                                                        else
                                                            safeGo(direction, gObject);

                                                        deferred.resolve();
                                                    }
                                                    else {
                                                        $transition$.abort();
                                                        safeGo(direction, gObject);
                                                        deferred.resolve();
                                                    }
                                                }
                                                else {
                                                    deferred.resolve();
                                                }
                                            }
                                            else {
                                                deferred.resolve();
                                            }
                                        }
                                        catch (err) {
                                            console.log(err);
                                            deferred.resolve();
                                        }
                                    }, function () {
                                        deferred.resolve();
                                    });
                                }
                                else {
                                    // if (force == 'redirect') {
                                    //     $transition$.abort();
                                    //     $transition$.router.stateService.go('analysis.country.value', { langcode: window.lang, country: $rootScope.country, satilik: $translate.instant('satilik'), konut: $translate.instant('konut') });
                                    // }
                                    deferred.resolve();
                                }
                                return deferred.promise;
                            }
                        ],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart('landing');
                            return $translate.refresh();
                        }],

                        titleLanding: ['$translate', function ($translate) {
                            return $translate('c_landing_title').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionLanding: ['$translate', function ($translate) {
                            return $translate('c_landing_desc').then(function (res) {
                                return res;
                            });
                        }],

                    },
                    metaTags: {
                        title: "{{titleLanding}}",
                        description: "{{descriptionLanding}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        }
                        // prerender: {
                        //     statusCode: ['langcode', function (langcode) {
                        //         return langcode ? 200 : 301;
                        //     }],
                        //     header: ['langcode', function (langcode) {
                        //         return langcode ? null : 'Location: https://www.endeksa.com/' + (window.lang ? window.lang : 'tr') + '/';
                        //     }]
                        // }
                    },
                })



                .state("atlas", {
                    url: "/:langcode/atlas",
                    templateUrl: "app/content/atlas/atlas.html",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    controller: "AtlasController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],
                        titleAtlas: ['$translate', function ($translate) {
                            return $translate('atlas_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionAtlas: ['$translate', function ($translate) {
                            return $translate('atlas_desc').then(function (res) {
                                return res;
                            });
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("atlas");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleAtlas}}",
                        description: "{{descriptionAtlas}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    }
                })

                .state("crm", {
                    url: "/:langcode/crm",
                    templateUrl: "app/content/crm/crm.html",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    controller: "CrmController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],
                        titleCrm: ['$translate', function ($translate) {
                            return $translate('crm_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionCrm: ['$translate', function ($translate) {
                            return $translate('crm_desc').then(function (res) {
                                return res;
                            });
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("crm");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleCrm}}",
                        description: "{{descriptionCrm}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    }
                })

                .state("startups", {
                    url: "/:langcode/e4s",
                    templateUrl: "app/content/startups/startups.html",
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    controller: "StartupsController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],
                        titleStartups: ['$translate', function ($translate) {
                            return $translate('startups_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionStartups: ['$translate', function ($translate) {
                            return $translate('startups_desc').then(function (res) {
                                return res;
                            });
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("startups");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleStartups}}",
                        description: "{{descriptionStartups}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    }
                })

                .state("hakkimizda", {
                    url: "/:langcode/{path:about|hakkimizda|sobre}",
                    templateUrl: "app/content/hakkimizda.html",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("hakkimizda");
                        }],
                    },
                    controller: "HakkimizdaController",
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],

                        // Using helper - much cleaner!
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleAboutUs: ['$translate', function ($translate) {
                            return $translate('c_about_title').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionAboutUs: ['$translate', function ($translate) {
                            return $translate('c_about_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("why_appraisal");

                            return $translate.refresh();
                        }],
                    },

                    metaTags: {
                        title: "{{titleAboutUs}}",
                        description: "{{descriptionAboutUs}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })

                .state("nasil", {
                    url: "/:langcode/{path:nasil|how|como}",
                    templateUrl: "app/content/howto.html",
                    controller: "HowToController",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("nasil");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleHow: ['$translate', function ($translate) {
                            return $translate('c_how_title').then(function (res) {
                                return res;
                            });
                        }],

                        descriptionHow: ['$translate', function ($translate) {
                            return $translate('c_how_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("services_edr");
                            $translatePartialLoader.addPart("howTo");

                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleHow}}",
                        description: "{{descriptionHow}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("iletisim", {
                    url: "/:langcode/{path:iletisim|contact|contactar|contato}",
                    templateUrl: "app/content/iletisim.html",
                    controller: "IletisimController",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("iletisim");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleContact: ['$translate', function ($translate) {
                            return $translate('c_contact_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionContact: ['$translate', function ($translate) {
                            return $translate('c_contact_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("contact");

                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleContact}}",
                        description: "{{descriptionContact}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("kullanim", {
                    url: "/:langcode/{path:kullanim|terms|termos|terminos}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/kullanim.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("kullanim");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleUse: ['$translate', function ($translate) {
                            return $translate('c_terms_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionUse: ['$translate', function ($translate) {
                            return $translate('c_terms_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleUse}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionUse}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })

                .state("cagri", {
                    url: "/:langcode/{path:cagri-merkezi|call-center|centro-de-llamadas|centro-de-atendimento}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/cagri.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("cagri");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleUse: ['$translate', function ($translate) {
                            return $translate('c_call_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionUse: ['$translate', function ($translate) {
                            return $translate('c_call_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleUse}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionUse}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("rehber", {
                    url: "/:langcode/{path:rehber-aktarim|directory-transfer|transferencia-de-diretorio|agenda-transferencia}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/rehber.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("rehber");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titleUse: ['$translate', function ($translate) {
                            return $translate('c_book_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionUse: ['$translate', function ($translate) {
                            return $translate('c_book_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleUse}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionUse}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                // .state("mortgageaydinlatma-tr", {
                //     url: "/tr/mortgage-aydinlatma",

                //     templateUrl: "app/content/sozlesme/mortgage-aydinlatma.html",
                //     lazyLoad: function ($transition$) {
                //         var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
                //         lazyLoad.inject('ngAnimate');
                //         lazyLoad.load([
                //             "/assets/css/main.content.min.css?v=" + window.appVersion
                //         ]);
                //         // lazyLoad.load({
                //         //     serie: true,
                //         //     delay: true,
                //         //     files: [
                //         //         "/assets/js/vendor.timekit.min.js?v=" + window.appVersion]
                //         // });
                //         return lazyLoad.load(
                //             {
                //                 serie: true,
                //                 files: [

                //                     "/assets/js/main.content.min.js?v=" + window.appVersion
                //                 ], insertBefore: '#last_script'
                //             }
                //         );
                //     },
                //     resolve: {
                //         titleUse: function () {
                //             return "Kişisel Verilerin Korunması Kanunu Hakkında Aydınlatma Metni";
                //         },
                //         descriptionUse: function () {
                //             return "Kişisel Verilerin Korunması Hakkında Aydınlatma Metni";
                //         },
                //     },
                //     metaTags: {
                //         title: "{{titleUse}}",
                //         robots: "noindex, nofollow",
                //         description: "{{descriptionUse}}",
                //         properties: {
                //             "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                //             "og:type": "website",
                //         },
                //     },
                // })
                .state("gizlilik", {
                    url: "/:langcode/{path:gizlilik|privacy|privacidad|privacidade}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/gizlilik.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("gizlilik");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titlePrivacy: ['$translate', function ($translate) {
                            return $translate('c_privacy_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionPrivacy: ['$translate', function ($translate) {
                            return $translate('c_privacy_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titlePrivacy}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionPrivacy}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("musteri-yonlendirme", {
                    url: "/:langcode/{path:danismanlik|consultancy|consultoria}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/lead.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("musteri-yonlendirme");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titlePrivacy: ['$translate', function ($translate) {
                            return $translate('c_consultancy_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionPrivacy: ['$translate', function ($translate) {
                            return $translate('c_consultancy_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titlePrivacy}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionPrivacy}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("cerez", {
                    url: "/:langcode/{path:cerez|cookie|biscoito}?device",
                    templateUrl: function () { return "app/content/sozlesme/" + window.lang + "/cerez.html"; },
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("cerez");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'legalPages');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtect();
                        }],

                        titlePrivacy: ['$translate', function ($translate) {
                            return $translate('c_cookie_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionPrivacy: ['$translate', function ($translate) {
                            return $translate('c_cookie_desc').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titlePrivacy}}",
                        robots: "noindex, nofollow",
                        description: "{{descriptionPrivacy}}",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("hizmetler", {
                    abstract: true,
                    url: "/:langcode/{path:hizmetler|services|servicios|servicos}",
                    template: "<ui-view/>",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("hizmetler");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'servicesPages');
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart('table_prices');
                            $translatePartialLoader.addPart("product_report");
                            return $translate.refresh();
                        }]
                    },
                })
                .state("hizmetler.otomatik", {
                    url: "/{path2:otomatik-degerleme|automated-valuation|valoracion-automatica|avaliacao-automatica}?ad",
                    templateUrl: "app/content/hizmet-otomatikdegerleme/hizmet-edr.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('otomatik');
                        }]
                    },
                    resolve: {

                        // Using two-path helper - much cleaner!
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_edr_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_edr_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("services_edr");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "EdrController",
                })
                .state("hizmetler.location", {
                    url: "/{path2:lokasyon-analizi|analisis-de-localizacion|analise-da-localizacao|location-analytics}?ad",
                    templateUrl: "app/content/hizmet-location/hizmet-location.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('location');
                        }]
                    },
                    resolve: {

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_location_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_location_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("services_location");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "LocationController",
                })
                .state("hizmetler.region", {
                    url: "/{path2:bolge-analizi|analisis-de-region|analise-da-regiao|region-analytics}?ad",
                    templateUrl: "app/content/hizmet-region/hizmet-region.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('region');
                        }]
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'servicesRegion');
                        }],

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_region_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_region_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("services_region");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "RegionController",
                })
                .state("hizmetler.guvenle-sat", {
                    url: "/lead?ad",
                    templateUrl: "app/content/hizmet-guvenle-sat/hizmet-guvenle-sat.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('danisman');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_sell_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_sell_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("consultant");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "ConfidenceController",
                })
                .state("hizmetler.danisman", {
                    url: "/{path2:guvenle-sat|vender-con-confianza|vender-com-confianca|sell-with-confidence}?ad",
                    templateUrl: "app/content/hizmet-danisman/hizmet-danisman.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('danisman');
                        }]
                    },
                    resolve: {

                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleEdr: ['$translate', function ($translate) {
                            return $translate('c_sell_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionEdr: ['$translate', function ($translate) {
                            return $translate('c_sell_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("consultant");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleEdr}}",
                        description: "{{descriptionEdr}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "DanismanController",
                })
                // .state("hizmetler-tr.mortgage", {
                //     url: "/mortgage?ad",
                //     templateUrl: "app/content/hizmet-mortgage/hizmet-mortgage.html",
                //     resolve: {
                //         titleEdr: function () {
                //             return "Kolay Konut Kredisi";
                //         },
                //         descriptionEdr: function () {
                //             return "Kolay konut kredisi çözümleri ile hemen, hızlı mortgage, eviniz için kullanın.";
                //         },
                //         keywordsEdr: function () {
                //             return "konut kredisi, hazır konut kredisi, ön onaylı kredi, mortgage, mortgage kullanma, hızlı kredi, hemen kredi";
                //         },
                //
                //translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                //             $translatePartialLoader.addPart("mortgage");
                //             $translatePartialLoader.addPart("product_report");
                //             return $translate.refresh();
                //         }],
                //     },
                //     metaTags: {
                //         title: "{{titleEdr}}",
                //         description: "{{descriptionEdr}}",
                //         robots: "index, follow",
                //         properties: {
                //             "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                //             "og:type": "website",
                //         },
                //     },
                //     controller: "MortgageServiceController",
                // })
                .state("urunler", {
                    abstract: true,
                    url: "/:langcode/{path:urunler|productos|produtos|products}",
                    template: "<ui-view/>",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("urunler");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'productsPages');
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("product_report");
                            return $translate.refresh();
                        }],
                    },
                })
                .state("urunler.kurumsal", {
                    url: "/api-widget?ad",
                    templateUrl: "app/content/urun-kurumsal/urun-kurumsal.html",
                    resolve: {
                        titleCoorporate: ['$translate', function ($translate) {
                            return $translate('c_api_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionCoorporate: ['$translate', function ($translate) {
                            return $translate('c_api_desc').then(function (res) {
                                return res;
                            });
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("product_enterprise");
                            $translatePartialLoader.addPart('table_prices');
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleCoorporate}}",
                        description: "{{descriptionCoorporate}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "KurumsalController",
                })
                .state("urunler.uyelik", {
                    url: "/{path2:uyelik|packages|paquetes|pacotes}?ad?promo",
                    templateUrl: "app/content/urun-uyelik/urun-uyelik.html",
                    controller: "PackagesController",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('uyelik');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleProdMembership: ['$translate', function ($translate) {
                            return $translate('c_pack_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionProdMembership: ['$translate', function ($translate) {
                            return $translate('c_pack_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("product_integration");
                            $translatePartialLoader.addPart('table_prices');
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleProdMembership}}",
                        description: "{{descriptionProdMembership}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                })
                .state("urunler.roket", {
                    url: "/{path2:roket|rocket|cohete|foguete}?ad",
                    templateUrl: "app/content/urun-roket/urun-roket.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant("roket");
                        }],
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleCoorporate: ['$translate', function ($translate) {
                            return $translate('c_rocket_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionCoorporate: ['$translate', function ($translate) {
                            return $translate('c_rocket_desc').then(function (res) {
                                return res;
                            });
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("product_rocket");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleCoorporate}}",
                        description: "{{descriptionCoorporate}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "RoketController",
                })

                .state("cozumler", {
                    abstract: true,
                    url: "/:langcode/{path:cozumler|solutions|soluciones|solucoes}",
                    template: "<ui-view/>",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("cozumler");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'solutionsPages');
                        }],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {

                            $translatePartialLoader.addPart("product_report");
                            return $translate.refresh();
                        }],
                    },
                })
                .state("cozumler.emlak-danismani", {
                    url: "/{path2:emlak-danismani|agents|agentes}?ad",
                    templateUrl: "app/content/kullanicilar-emlak-uzmanlari/emlak-uzmanlari.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('emlak-danismani');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleConsultant: ['$translate', function ($translate) {
                            return $translate('c_agent_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionConsultant: ['$translate', function ($translate) {
                            return $translate('c_agent_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("experts");
                            $translatePartialLoader.addPart("solutions");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleConsultant}}",
                        description: "{{descriptionConsultant}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "EmlakUzmaniController",
                })
                .state("cozumler.degerleme", {
                    url: "/{path2:degerleme-kuruluslari|appraisers|tasadores|avaliadores}?ad",
                    templateUrl: "app/content/kullanicilar-degerleme-uzmanlari/degerleme-uzmanlari.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('degerleme');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleProfessional: ['$translate', function ($translate) {
                            return $translate('c_app_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionProfessional: ['$translate', function ($translate) {
                            return $translate('c_app_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("evaluation_experts");
                            $translatePartialLoader.addPart("solutions");
                            return $translate.refresh();
                        }]
                    },
                    metaTags: {
                        title: "{{titleProfessional}}",
                        description: "{{descriptionProfessional}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "DegerlemeUzmaniController",
                })
                .state("cozumler.yatirimci", {
                    url: "/{path2:bireysel|individuals|individuos|particulares}?ad?promo",
                    templateUrl: "app/content/kullanicilar-yatirimci/yatirimci.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('yatirimci');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        trans: "$transition$",
                        titleInvestors: ['$translate', function ($translate) {
                            return $translate('c_ind_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionInvestors: ['$translate', function ($translate) {
                            return $translate('c_ind_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("analysis_value");
                            $translatePartialLoader.addPart("investors");
                            $translatePartialLoader.addPart("solutions");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleInvestors}}",
                        description: "{{descriptionInvestors}}",
                        robots: [
                            "$transition$",
                            function ($transition$) {
                                if ($transition$.params().ad) return "noindex, nofollow";
                                else return "index, follow";
                            },
                        ],
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "YatirimciController",
                })

                .state("cozumler.perakende", {
                    url: "/{path2:kurumsal|enterprise|empresa|empreendimento}?ad?promo",
                    templateUrl: "app/content/kullanicilar-perakende/perakende.html",
                    params: {
                        path2: ['$translate', function ($translate) {
                            return $translate.instant('perakende');
                        }]
                    },
                    resolve: {
                        LangProtect: ['routeHelpers', function (routeHelpers) {
                            return routeHelpers.langProtectTwoPath();
                        }],

                        titleDeveloper: ['$translate', function ($translate) {
                            return $translate('c_enter_title').then(function (res) {
                                return res;
                            });
                        }],
                        descriptionDeveloper: ['$translate', function ($translate) {
                            return $translate('c_enter_desc').then(function (res) {
                                return res;
                            });
                        }],


                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("retail");
                            $translatePartialLoader.addPart("solutions");
                            return $translate.refresh();
                        }],
                    },
                    metaTags: {
                        title: "{{titleDeveloper}}",
                        description: "{{descriptionDeveloper}}",
                        robots: "index, follow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    controller: "PerakendeController",
                })
                .state("investment", {
                    url: "/:langcode/investment-detail?propertyId&propertyCategory",
                    templateUrl: "app/content/investment/investmentDetail.html",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    resolve: {
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("content");
                            return $translate.refresh();
                        }],
                        title: ['$translate', function ($translate) {
                            return $translate('c_an_find1').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{title}}",
                        description: "{{description}}",
                        robots: "noindex, nofollow",
                        properties: {
                            "og:image": "http://www.endeksa.com/share3.jpg", "og:image:secure_url": 'https://www.endeksa.com/share3.jpg',
                            "og:type": "website",
                        },
                    },
                    //controller: "PerakendeController",
                })
                .state("404", {
                    url: "/:langcode/404",
                    templateUrl: "app/content/404.html",
                    title: "404",
                    params: {

                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'contentPages');
                        }],

                        titleError404: ['$translate', function ($translate) {
                            return $translate('c_404').then(function (res) {
                                return res;
                            });
                        }]
                    },
                    metaTags: {
                        title: "{{titleError404}}",
                        robots: "noindex, nofollow",
                        prerender: {

                            statusCode: "404",
                        },
                    },
                });


        }
    ]);

})();
